import scrabblemini from "../Assets/scrabblemini.png";
import arraybatcher from "../Assets/array-batcher.png";

export const ImageMapping = new Map<number, string>([
    [144539107, scrabblemini],
    [209708338, arraybatcher]
]);

export const Downloads = new Set<number>([144539107, 144551523, 144554761, 144562886, 144564354]);